export default 'USER_CLICKED_VOLUME_TOGGLE';
